// Carry Roll SessionsScreen — Screen 4. List/trends + detail rail.

import { Collapsible } from '../components/calculator/Collapsible';
import { SessionList } from '../components/sessions/SessionList';
import { TrendsView } from '../components/sessions/TrendsView';
import { ProfilesPanel } from '../components/sessions/ProfilesPanel';
import { AveragingControls } from '../components/sessions/AveragingControls';
import { CsvImport } from '../components/sessions/CsvImport';

export default function SessionsScreen() {
  return (
    <div className="measure flex flex-col gap-4" data-testid="sessions-screen">
      <h2 className="section-title">
        Sessions
      </h2>
      <div className="grid gap-4 grid-cols-1 lg:grid-cols-[minmax(0,2fr)_minmax(0,1fr)]">
        <div className="flex flex-col gap-4">
          <SessionList />
          <TrendsView />
        </div>
        <div className="flex flex-col gap-4">
          <Collapsible title="Profiles" testId="sessions-profiles">
            <ProfilesPanel />
          </Collapsible>
          <Collapsible title="Averaging controls" testId="sessions-averaging">
            <AveragingControls />
          </Collapsible>
          <Collapsible title="Import" testId="sessions-import" defaultOpen={false}>
            <CsvImport />
          </Collapsible>
        </div>
      </div>
    </div>
  );
}
